<app-private-sidebar
  [opened]="menuOpen()"
  [isMobile]="isMobile()"
  (navigate)="closeMenuIfMobile()"
  (close)="toggleMenu()"
></app-private-sidebar>

<div class="layout-body" [class.no-scroll]="isMobile() && menuOpen()">
  <app-private-header
    [mode]="headerMode()"
    [title]="headerTitle()"
    [subtitle]="headerSubtitle()"
    [titleKey]="headerTitleKey()"
    [subtitleKey]="headerSubtitleKey()"
    [titleParams]="headerTitleParams()"
    [subtitleParams]="headerSubtitleParams()"
    [icon]="headerIcon()"
    [showBack]="headerShowBack()"
    [backTo]="headerBackTo"
    [showMenuButton]="isMobile() && headerMode() === 'default'"
    (menuClick)="toggleMenu()"
  ></app-private-header>

  <main class="main">
    <router-outlet (activate)="onActivate($event)" (deactivate)="onDeactivate()"></router-outlet>
  </main>
</div>

@if (isMobile() && menuOpen()) {
  <div class="backdrop" (click)="toggleMenu()"></div>
}
